import { ShueishaIdAuthType } from '@/features/account/types';
import { swal } from '@/lib/sweetalert';
import { getShueishaIdAuthParam } from '../api/getShueishaIdAuthParam';
import { getShueishaIdAuthParamForWithdrawal } from '../api/getShueishaIdAuthParamForWithdrawal';

const getMethodParam = (type: ShueishaIdAuthType) => {
  switch (type) {
    case ShueishaIdAuthType.auth:
      return 'login';
    case ShueishaIdAuthType.changedEmail:
      return 'user/change_email';
    case ShueishaIdAuthType.changedPassword:
      return 'user/change_password';
    case ShueishaIdAuthType.withdrawal:
      return 'user/withdraw';
    default:
      return 'login';
  }
};

const getCodeChallenge = async (type: ShueishaIdAuthType, callbackPagePath?: string) => {
  // コールバックページのURLを取得
  const callbackPageUrl = callbackPagePath
    ? encodeURIComponent(`${process.env.NEXT_PUBLIC_BASE_URL}${callbackPagePath}`)
    : undefined;

  switch (type) {
    case ShueishaIdAuthType.withdrawal: {
      const { result: withdrawalResult } = await getShueishaIdAuthParamForWithdrawal();
      return withdrawalResult.codeChallenge;
    }
    default: {
      const { result: defaultResult } = await getShueishaIdAuthParam(type, callbackPageUrl);
      return defaultResult.codeChallenge;
    }
  }
};

const getCallbackUrl = (type: ShueishaIdAuthType) => {
  switch (type) {
    case ShueishaIdAuthType.auth:
      return '/auth/signin/callback';
    default:
      return '/account/callback';
  }
};

export const goShueishaIdAuth = async ({
  type,
  email,
  callbackPagePath,
}: {
  type: ShueishaIdAuthType;
  email?: string;
  callbackPagePath?: string;
}): Promise<void> => {
  if (typeof window === 'undefined') {
    console.warn('クライアントコンポーネントでのみ利用可能です');
    return;
  }

  try {
    const methodParam = getMethodParam(type);
    const codeChallenge = await getCodeChallenge(type, callbackPagePath);
    sessionStorage.setItem('codeChallenge', codeChallenge);

    const baseUrl = process.env.NEXT_PUBLIC_SHUEISHA_ID_BASE_URL;
    const callbackPath = getCallbackUrl(type);
    const callbackUrl = encodeURIComponent(`${process.env.NEXT_PUBLIC_BASE_URL}${callbackPath}`);
    const encodedCodeChallenge = encodeURIComponent(codeChallenge);
    let href = `${baseUrl}/linkage/jump_labo/${methodParam}?callback=${callbackUrl}&code_challenge=${encodedCodeChallenge}`;
    if (email) {
      href += `&email=${encodeURIComponent(email)}`;
    }
    window.location.href = href;
  } catch (_error) {
    await swal.alert({
      html: 'SHUEISHA IDサイトへの遷移に失敗しました。<br>ジャンプLAB事務局に問い合わせてください。',
    });
    window.location.href = '/contact';
  }
};
